import axios from 'axios';

const $axios = axios.create({
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export default $axios;



// WEBPACK FOOTER //
// ./src/helpers/axios-instance.js